import { BoxV4 } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import clsx from 'clsx'

import {
  CombinedFormDimension,
  CombinedFormState,
} from '../../../../modules/combinedForm/reducer'
import { useStyles } from './PlansView.styles'

interface PlansViewProp {
  combinedFormData: CombinedFormState | undefined
}

export const PlansView = ({ combinedFormData }: PlansViewProp) => {
  const { classes } = useStyles()

  const dimensions = (combinedFormData?.resellerAgreementData.dimensions ||
    []) as CombinedFormDimension[]
  return (
    <BoxV4
      style={{ padding: '32px' }}
      heading="Plans"
      headingIcon={
        <FontAwesomeIcon
          icon={faShelves}
          style={{ width: '18px', height: '14px' }}
        />
      }
      variant="small"
      headingVariant="small"
    >
      <div className={clsx(classes.root, classes.elementsGap)}>
        <div className={classes.titleWraper}>
          <Typography className={clsx(classes.sectionText, classes.columnName)}>
            Dimension
          </Typography>
          <Typography
            className={clsx(classes.sectionText, classes.columnPrice)}
          >
            Quantity
          </Typography>
        </div>

        <div className={classes.border}></div>

        {dimensions.map((dimension, index) => {
          const dimensionKey = dimension.id || index
          const isLast = index === dimensions.length - 1
          return dimension.type === 'standard' ? (
            <div key={dimensionKey}>
              <div className={classes.resourceRow} data-testid="dimensions-row">
                <div className={classes.resourcesContainer}>
                  <div
                    className={classes.columnName}
                    key={`combinedFormData.resellerAgreementData.dimensions-${dimensionKey}-paymentDate`}
                  >
                    <div
                      className={clsx(
                        classes.alignDescription,
                        classes.wordWrap
                      )}
                      data-testid="description-select"
                    >
                      <Typography className={classes.textClass}>
                        {dimension.label}
                      </Typography>
                    </div>
                  </div>

                  <div
                    key={`dimensions-${dimensionKey}-quantity`}
                    className={clsx(classes.columnPrice)}
                  >
                    <Typography style={{ fontSize: '14px', color: '#2E3132' }}>
                      {dimension.quantity}
                    </Typography>
                  </div>
                </div>
              </div>
              {!isLast && <div className={classes.border}></div>}
            </div>
          ) : null
        })}
      </div>
    </BoxV4>
  )
}
